<ng-doc-root>
	<ng-doc-navbar [leftContent]="leftContent" [rightContent]="rightContent">
		<ng-template #leftContent>
			<h3 routerLink="">M-theme/M-ui</h3>
		</ng-template>
		<ng-template #rightContent>
			<label id="switch" class="switch">
				<input type="checkbox" (change)="switchTheme()" [checked]="theming === THEME.LIGHT" id="slider">
				<span class="slider round"></span>
			</label>
		</ng-template>
	</ng-doc-navbar>
	<ng-doc-sidebar></ng-doc-sidebar>
	<router-outlet></router-outlet>
</ng-doc-root>
